﻿/**
 * birthday.repository
 * @namespace portal
 * @description This should probably move to a separate module for the DataWarehouse once it has a web application, or we move to the CDN
 */

(function () {
	'use strict';

	/** add the repo */
	angular.module('nha.portal').service('birthday.repository', birthdayRepo);

	/** injection */
	birthdayRepo.$inject = ['repositoryFactory', 'DataWarehouseRestangular'];

	/** implementation */
	function birthdayRepo(repositoryFactory, dataWarehouseRestangular) {
		/** create the repo */
		var repo = new repositoryFactory('Birthday', dataWarehouseRestangular);

		/** return the repo */
		return repo;
	}
})();